import { ISkillRatingOption, ISkillRatingOptionServerside, SkillRatingOption } from './skill-rating-option.model';

export class SkillRatingConfiguration implements ISkillRatingConfiguration {
  id: number;
  scoreCount: number;
  scoreIcon: string;
  options: SkillRatingOption[];
  createdAt: Date;
  updatedAt: Date;

  constructor(serverside: ISkillRatingConfigurationServerside) {
    this.id = serverside.id;
    this.scoreCount = serverside.scoreCount;
    this.scoreIcon = serverside.scoreIcon;
    this.options = serverside.options.map(option => new SkillRatingOption(option)).sort((a, b) => a.scoreValue - b.scoreValue);
    this.createdAt = new Date(serverside.createdAt);
    this.updatedAt = new Date(serverside.updatedAt);
  }

  public static DEFAULT_5_PART: SkillRatingConfiguration = new SkillRatingConfiguration({
    scoreCount: 5,
    scoreIcon: 'fa-star',
    options: [
      { id: null, scoreValue: 0, name: 'Not demonstrated', description: 'The employee does not exhibit this skill in their role.' },
      { id: null, scoreValue: 1, name: 'Basic understanding', description: 'The employee has a basic understanding of this skill but requires supervision.' },
      { id: null, scoreValue: 2, name: 'Developing', description: 'The employee demonstrates this skill to a satisfactory level but is still developing.' },
      { id: null, scoreValue: 3, name: 'Proficient', description: 'The employee demonstrates this skill independently and effectively.' },
      { id: null, scoreValue: 4, name: 'Expert', description: 'The employee is an expert in this skill, often mentoring others and improving processes.' }
    ],
    id: null,
    createdAt: null,
    updatedAt: null
  });
  public static DEFAULT_4_PART: SkillRatingConfiguration = new SkillRatingConfiguration({
    scoreCount: 4,
    scoreIcon: 'fa-star',
    options: [
      { id: null, scoreValue: 0, name: 'Not demonstrated', description: 'The employee does not exhibit this skill in their role.' },
      { id: null, scoreValue: 1, name: 'Developing', description: 'The employee demonstrates a basic understanding of this skill but requires supervision and further development.' },
      { id: null, scoreValue: 2, name: 'Proficient', description: 'The employee demonstrates this skill independently and effectively.' },
      { id: null, scoreValue: 3, name: 'Expert', description: 'The employee is an expert in this skill, often mentoring others and improving processes.' }
    ],
    id: null,
    createdAt: null,
    updatedAt: null
  });
  public static DEFAULT_3_PART: SkillRatingConfiguration = new SkillRatingConfiguration({
    scoreCount: 3,
    scoreIcon: 'fa-star',
    options: [
      { id: null, scoreValue: 0, name: 'Developing', description: 'The employee demonstrates a basic understanding of this skill but requires supervision and further development.' },
      { id: null, scoreValue: 1, name: 'Proficient', description: 'The employee demonstrates this skill independently and effectively.' },
      { id: null, scoreValue: 2, name: 'Expert', description: 'The employee is an expert in this skill, often mentoring others and improving processes.' }
    ],
    id: null,
    createdAt: null,
    updatedAt: null
  });

  public static DEFAULT: SkillRatingConfiguration = SkillRatingConfiguration.DEFAULT_3_PART;
  public static DEFAULT_OPTIONS: SkillRatingConfiguration[] = [SkillRatingConfiguration.DEFAULT_3_PART, SkillRatingConfiguration.DEFAULT_4_PART, SkillRatingConfiguration.DEFAULT_5_PART];

  public getOption(scoreValue: number): SkillRatingOption {
    return this.options.find(option => option.scoreValue === scoreValue);
  }

}

export interface ISkillRatingConfiguration {
  id: number;
  scoreCount: number;
  scoreIcon: string;
  options: ISkillRatingOption[];
  createdAt: Date;
  updatedAt: Date;
}


export interface ISkillRatingConfigurationServerside {
  id: number;
  scoreCount: number;
  scoreIcon: string;
  options: ISkillRatingOptionServerside[];
  createdAt: string;
  updatedAt: string;
}
